import { render, staticRenderFns } from "./UpdateVehicleDriverModal.vue?vue&type=template&id=f23d940a&"
import script from "./UpdateVehicleDriverModal.vue?vue&type=script&lang=js&"
export * from "./UpdateVehicleDriverModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateVehicleDriverModal.vue?vue&type=style&index=0&id=f23d940a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports